<template>
 <div id="app" v-title data-title="租户保">
    <!-- <Header/> -->
    <router-view></router-view>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
name: 'App',
components: {},
data() {
//这里存放数据
return {

};
},
metaInfo: {
    title: "租户保",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" },
      
    ],
  },
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  
},
beforeCreate() {}, //生命周期 - 创建之前
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
beforeMount() {}, //生命周期 - 挂载之前
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  
},
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
  @import "./assets/css/base.css";
  @import "./assets/fonts/iconfont.css";
  #app{
    width: 100%;
    height: 100%;
    max-width: 768px;
    max-height: 90rem;
    margin: 0 auto;
  }
  html{
     /* overflow: hidden; */
    height: 100%;

  }
  body{
    width: 100%;
    height: 100%;
    /* overflow: hidden; */
    /* overflow: scroll; */
  }
  @media screen and (min-width:500px) {
    html{
      /* overflow: scroll; */
      background: #e4e7ed;
    }
    #app{
    /* overflow: scroll; */
    height: 100%;

    }
    body {
        width: 37.5rem;
        height: 75rem;
        margin: 5rem auto;
        background: #ffffff;
       
    }
}
  /* body{
    width: 100%;
    max-width: 37.5rem;
    height: 667px;
  } */
</style>
<!--  -->

